import React from "react";
import Note from "../Note/Note";

function NewNote({
  account_slug,
  project_id,
  projectStatus,
  notes,
  noteId,
  account_id,
  setNoteCreated,
  currentUser
}) {
  return (
    <Note
      account_slug={account_slug}
      project_id={project_id}
      projectStatus={projectStatus}
      notes={notes}
      currentUser={currentUser}
      noteId={noteId}
      account_id={account_id}
      setNoteCreated={setNoteCreated}
    />
  );
}

export default NewNote;